import React, { useState } from 'react';
import { Modal, Typography } from 'antd';

const { Paragraph, Link } = Typography;

const FinanceData = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    window.open('https://www40.polyu.edu.hk/fofip/', '_blank');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <div onClick={showModal}>Finance Data</div>
      <Modal
        title="Project Financial Reports"
        width={800}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Proceed to FIP"
      >
        <Paragraph>
          You will redirect to{' '}
          <Link href="https://www40.polyu.edu.hk/fofip/" target="_blank">
            FO Financial Information Platform (FIP)
          </Link>{' '}
          to view the financial report of your project(s).
        </Paragraph>
        <Paragraph>
          <Link
            href="https://www2.polyu.edu.hk/fo/FO_Web/FO_Doc/FTStaff/FT_FS/FT_FS_FR/FIP_User_Manual.pdf"
            target="_blank"
          >
            Read User Manual
          </Link>
        </Paragraph>
      </Modal>
    </>
  );
};

export default FinanceData;
